export enum KpiEnum {
  QUERIES = 'queries',
  CLICKS = 'clicks',
  FINDABILITY = 'findability',
  ADD2CART = 'add2cart',
  CHECKOUT = 'checkout',
  NO_RESULTS = 'no-results',
  SESSIONS = 'sessions',
  QUERIES_PER_SESSION = 'queriesPerSession',
  VIEW = 'view',
  POSITION_AVG = 'positionAvg',
  SEMANTICS_QUERIES = 'semanticsQueries',
  CONVERSION = 'conversion',
}
